import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { UserSidePathUrl } from '../../../common/config';
import * as configuration from '../../../utils/configuration';
import dateformat from 'dateformat';
import { FormProvider, useForm } from 'react-hook-form';
//--- Material Table
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    TextField
} from '@material-ui/core';

import FooterPagination from '../../../components/footer-pagination/pagination';

import {
    APIUrlDefault,
    DomainUserSide,
} from '../../../utils/configuration';

//--- Material Icon
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/Restore';

// import AssignmentIcon from '@material-ui/icons/Assignment';
// import AddCommentIcon from '@material-ui/icons/AddComment';
//--- Material Control
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { convertWallet } from '../../../utils/helpers/convertWallet';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    tableContainer: {
        maxHeight: window.outerHeight - 365,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    pointer: { cursor: 'pointer' },
}));

const listStatus = [
    { id: 1, name: 'Chờ xử lý', color: '#FF9800' },
    { id: 2, name: 'Đã xác nhận', color: '#2196F3' },
    { id: 3, name: 'Đang giao', color: '#9C27B0' },
    { id: 4, name: 'Hoàn thành', color: '#4CAF50' },
]

const headCells = [
    // { id: 'img', hideSortIcon: true, label: 'Ảnh' },
    { id: 'name', hideSortIcon: true, label: 'Tên' },
    { id: 'phone', hideSortIcon: true, label: 'Số điện thoại' },
    { id: 'email', hideSortIcon: true, label: 'Email' },
    { id: 'address', hideSortIcon: true, label: 'Địa chỉ' },
    { id: 'quantity', hideSortIcon: true, label: 'Số lượng' },
    { id: 'langId', hideSortIcon: true, label: 'Ngôn ngữ' },
    { id: 'note', hideSortIcon: true, label: 'Ghi chú' },
    { id: 'status', hideSortIcon: true, label: 'Trạng thái' },
    { id: 'createdBy', hideSortIcon: true, label: 'Người tạo' },
    { id: 'modifiedDate', hideSortIcon: true, label: 'Ngày cập nhật' },
    { id: 'modifiedBy', hideSortIcon: true, label: 'Người cập nhật' },
    { id: 'actions', hideSortIcon: true, label: '' },
];

const ListEdition = (props) => {
    const { listModel, deleteAction, editAction, handleUpdateStatus, pagination } = props;
    return (
        <>
            {listModel.length > 0 ? (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {headCells.map(item => (
                                    <TableCell key={item.id}>
                                        {item.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listModel.map(row => (
                                <TableRow key={row.id}>
                                    <TableCell>
                                        {row?.name}
                                    </TableCell>
                                    <TableCell>
                                        {row?.phone}
                                    </TableCell>
                                    <TableCell>
                                        {row.email}
                                    </TableCell>
                                    <TableCell>
                                        {row.address}
                                    </TableCell>
                                    <TableCell>
                                        {row?.quantity}
                                    </TableCell>
                                    <TableCell>
                                        {row?.langId === 'vi' ? 'Tiếng Việt' : 'Tiếng Anh'}
                                    </TableCell>
                                    <TableCell>
                                        {row?.note}
                                    </TableCell>
                                    <TableCell>
                                        <Autocomplete
                                            id='combo-box-demo'
                                            options={listStatus}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, value) => handleUpdateStatus(row.id, value.id)}
                                            style={{ width: '100%', minWidth: '150px' }}
                                            value={listStatus.find((item) => item.id === row.status)}
                                            defaultValue={{
                                                id: row.status,
                                                name: row.statusName,
                                            }}
                                            disableClearable={true}
                                            renderOption={(option) => (
                                                <span style={{
                                                    color: option.color,
                                                    fontWeight: 600
                                                }}>
                                                    {option.name}
                                                </span>
                                            )}
                                            renderInput={(params) => {
                                                const selectedOption = listStatus.find((item) => item.id === row.status);
                                                const statusClass = `status-field-${row.id}`;
                                                return (
                                                    <>
                                                        <style>{`
                                                            .${statusClass} .MuiOutlinedInput-notchedOutline {
                                                                border-color: ${selectedOption?.color} !important;
                                                                border-width: 2px !important;
                                                            }
                                                        `}</style>
                                                        <TextField
                                                            {...params}
                                                            variant='outlined'
                                                            name="realEstateTypeId"
                                                            size="small"
                                                            className={statusClass}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                style: {
                                                                    color: selectedOption?.color,
                                                                    fontWeight: 600
                                                                }
                                                            }}
                                                        />
                                                    </>
                                                );
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        {row?.createdBy === 'System' ? 'Khách' : row?.createdBy}
                                    </TableCell>
                                    <TableCell>
                                        {dateformat(row?.modified_date, 'dd/mm/yyyy')}
                                    </TableCell>
                                    <TableCell>
                                        {row?.modifiedBy}
                                    </TableCell>
                                    <TableCell align='right' className='text-nowrap'>
                                        {/* <Tooltip title='Sửa'>
                                            <IconButton
                                                aria-label='edit'
                                                onClick={() => editAction(row)}>
                                                <EditIcon className='text-primary' />
                                            </IconButton>
                                        </Tooltip> */}
                                        <Tooltip title='Xóa'>
                                            <IconButton
                                                aria-label='delete'
                                                onClick={() => deleteAction(row.id)}>
                                                <DeleteIcon className='text-danger' />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <>chưa tạo</>
            )}
            {pagination.totalItemCount && pagination.totalItemCount > 0 ? (
                <FooterPagination
                    showFirstLastButton
                    currentPage={pagination.pageIndex}
                    totalPage={pagination.pageCount}
                    totalItemCount={pagination.totalItemCount}
                    pageLimit={pagination.pageSize}
                />
            ) : (
                ''
            )}
        </>
    )
}

export default ListEdition;